import React, { Component } from 'react'
import Link from '../utils/link'
import PropertyOptionCard from './cards/property-option'

class PropertyOptions extends Component {

  constructor(props) {
    super(props)
    this.slider = React.createRef()
  }

  componentDidMount() {
    let isDown = false;
    let startX;
    let scrollLeft;
    this.initial = 0;

    this.slider.current.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.pageX - this.slider.current.offsetLeft;
      scrollLeft = this.slider.current.scrollLeft;
      this.initial = 0;
    });
    this.slider.current.addEventListener('mouseleave', (event) => {
      isDown = false;
    });
    this.slider.current.addEventListener('mouseup', (event) => {
      isDown = false;
    });
    this.slider.current.addEventListener('mousemove', (event) => {
      if(!isDown) return;
      event.preventDefault();
      const x = event.pageX - this.slider.current.offsetLeft;
      const walk = (x - startX) * 2; //scroll-fast
      this.initial += Math.abs(walk);
      this.slider.current.scrollLeft = scrollLeft - walk;
    });
  }

  sliderLink = (event) => {
    if (this.initial > 10) event.preventDefault();
  }

  render() {

    let { title, items, menu, button, theme } = this.props

    return (
      <section className={`property-options ${theme}-theme`}>
        { title &&
          <div className='property-options__heading'> 
            <h2> { title }</h2>
          </div>
        }
        <div className='property-options__content'> 
          <div className='property-options__menu'> 
            { menu?.length > 0 &&  
              <ul>
                {menu.map((el, i) => (
                  <li className={i === 0 && 'active'} key={i}><Link to={el.link}>{ el.text }</Link></li>
                ))}
              </ul>
            }
            { button.link &&
              <Link to={button.link} className="btn">{ button.text }</Link>
            }
          </div>
          { items?.length > 0 && 
            <div className='property-options__slides'>
              <div className='property-options__slider' ref={this.slider}>
                {items.map((el, i) => (
                  <PropertyOptionCard {...el} key={i} onClick={this.sliderLink} />
                ))}
              </div>
            </div>
          }
        </div>
      </section>
    )
  }
}

export default PropertyOptions
